import React from "react";
import InputDatoProdotto from "../elementiPagina/InputDatoProdotto";

function Debug(props) {
        
    const prodottoTemp=props.prodottoTemp; 
    const handleChange = props.datoOnChange;
    const datoClass = props.datoClass;

    return (
        <div>
            <InputDatoProdotto 
                            inputLabel="Codice 2bit"
                            datoName="codice2bit"
                            datoId="codice2bit"
                            datoValue={prodottoTemp?.codice2bit ?? ""}
                            datoPlaceHolder=""
                            datoOnChange={handleChange}
                            datoClass={datoClass}
                            classiTastoSblocco="dn"
                            tastoCopiaAspetto="dn"
                        />
            <InputDatoProdotto 
                            inputLabel="Codice Prestashop"
                            datoName="codicePS"
                            datoId="codicePS"
                            datoValue={prodottoTemp?.codicePS ?? ""}
                            datoPlaceHolder=""
                            datoOnChange={handleChange}
                            datoClass={datoClass}
                            classiTastoSblocco="dn"
                            tastoCopiaAspetto="dn"
                        />
            <InputDatoProdotto 
                            inputLabel="Attivo su ps"
                            datoName="attivo"
                            datoId="attivo"
                            datoValue={prodottoTemp?.attivo ?? ""}
                            datoPlaceHolder=""
                            datoOnChange={handleChange}
                            datoClass={datoClass}
                            classiTastoSblocco="dn"
                            tastoCopiaAspetto="dn"
                        />
            <small>scrivi 1 per sì, 0 per no, su ps è un boolean, vedere come fare</small>
            <h4>prodottoTemp state</h4>
            <pre>{JSON.stringify(prodottoTemp, null, 2)}</pre>
        </div>
    )



}

export default Debug;
